const URL = {
  BASE_URL_SMART: "https://cloud.smartanalytics.io/",
  BASE_URL_ENER: "https://cloud.enginer.io"
};

const API = {
  ENV: "prod",
  API_URL: "https://api.smartanalytics.io/api/",
  API_STAT_URL: "https://new-api-stat.smartanalytics.io/api/",
  APPS_URL: "https://apps.smartanalytics.io/",
  APPS_PLATFORM_ID: "prod",
  COUNTER: "",
};

const AUTH = {
  REGISTER: "auth/",
  USER_LOGIN: "user_profile/",
  REF_LINK: "auth-new/jwt/token/refresh/",
  LOGIN: "auth-new/token/create/",
  LOGIN_FB: "fb/auth/",
  LOGIN_GOOGLE: "google/auth/",
  LOGIN_YANDEX: "yandex/auth/",
  LOGIN_MAIL: "mailru/auth/",
  LOGIN_ELAMA: "elama/auth/",
  LOGOUT: "auth-new/token/destroy/",
  RESET_PASSWORD_REQUEST: "auth-new/password/reset/",
  RESET_PASSWORD: "auth-new/password/reset/confirm/",

  URL: URL.BASE_URL_SMART,
  URL_ENER: URL.BASE_URL_ENER + "/analytics/dev/",
  CALLBACK_URL: (type, locale) => {
    if (type == "smart") {
      return URL.BASE_URL_SMART + `new-auth/#/${locale}/login`;
    } else if (type == "ener") {
      return URL.BASE_URL_ENER + `/#/${locale}/login`;
    } else {
      return type + `/new-auth/#/${locale}/login`;
    }
  }
};
 
const GOOGLE = {
  ID: "495468247144-pp2id3q5oe50ic8f750lohrkdrpvdqkf.apps.googleusercontent.com"
};

export { API, AUTH, GOOGLE };
